import { isEmpty } from 'lodash'
import React from 'react'

import TypeString from '#/components/FormatCell/Types/string'

const TypeSequencer = ({ value, reverse = false, attrName = '' }) => {
  if (isEmpty(value) || !Array.isArray(value)) return '-'

  const list = reverse ? [...value].reverse() : value

  const text = list.map(item => (attrName ? item[attrName] : item)).join(', ')

  return <TypeString value={text} />
}

export default TypeSequencer
